module.exports = __webpack_public_path__ + "img/Vector933.08402f36.png";